import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
//msalConfig
import { msalConfig } from './authConfig';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../src/components/store/index';


const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
            <Provider store={store}>
               
                <BrowserRouter>
                  
                        <App />
                   
                </BrowserRouter>
                
      </Provider>
    </MsalProvider>
  </React.StrictMode>
);

